export default __webpack_public_path__ + "static/img3_final-a610e2ce53f903a7f36812d12fb60cf1.png";